import { render, staticRenderFns } from "./tags-nav.vue?vue&type=template&id=9d2332d0"
import script from "./tags-nav.vue?vue&type=script&lang=js"
export * from "./tags-nav.vue?vue&type=script&lang=js"
import style0 from "./tags-nav.vue?vue&type=style&index=0&id=9d2332d0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d2332d0')) {
      api.createRecord('9d2332d0', component.options)
    } else {
      api.reload('9d2332d0', component.options)
    }
    module.hot.accept("./tags-nav.vue?vue&type=template&id=9d2332d0", function () {
      api.rerender('9d2332d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/layout/tags-nav/tags-nav.vue"
export default component.exports